/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param model
 * @param setModel
 * @returns {{handleChange: (function(*=, *=, *=, *=): void)}}
 * @constructor
 */
const HandleChange = ({ model, setModel }) => {
    const handleChange = (evt, name = '', child = '', subChild = '') => {

        if (!evt) {
            setModel({ ...model, [name]: evt });
            return;
        }

        let value = evt.target.value;

        if (name === '' || typeof name === 'object') {
            name = evt.target.name;
        }

        if (evt?.target?.type === 'checkbox') {
            value = evt.target.checked;
        }

        if (evt?.target?.type === 'radio') {
            value = value === 'true' || value === true;
        }

        if (child && typeof subChild === "number") {
            setModel((prev) => ({
                ...prev,
                [child]: prev[child].map((item, i) =>
                    i === subChild ? { ...item, [name]: value } : item
                )
            }));
            return;
        }

        if (child && !subChild) {
            setModel((prev) => ({
                ...prev,
                [child]: { ...prev[child], [name]: value },
            }));
            return;
        }

        if (child && subChild) {
            setModel((prev) => ({
                ...prev,
                [child]: {
                    ...prev[child],
                    [subChild]: {
                        ...prev[child][subChild],
                        [name]: value,
                    },
                },
            }));
            return;
        }

        setModel((prevState) => ({ ...prevState, [name]: value }));
    };

    return { handleChange };
};


export default HandleChange;
